import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class SssCoreService {

  constructor() { }

  helloSss() {
    return 'Hello, Sss!';
  }
}
